// @module Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey
define('Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.View'
,	[
	'tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey.tpl'
	
	,	'Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation.View'
	,	'Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Validation.View'
	,	'Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Model'
	,	'Backbone'
	,	'Utils'
	,	'jQuery'
	,	'underscore'	
    ]
, function (
	tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_tpl
	
	,	CustomerFeedbackSurveyConfirmationView
	,	CustomerFeedbackSurveyValidationView
	,	CustomerFeedbackSurveyModel
	,	Backbone
	,	Utils
	,	jQuery
	,	_
)
{
    'use strict';

	// @class Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_tpl

    	// @property {String} title
    ,	title: Utils.translate('Feedback')

    	// @property {String} page_header
    ,	page_header: Utils.translate('Feedback')

	,	initialize: function (options) {
		
			Backbone.View.prototype.initialize.apply(this, arguments);

			var self = this;

			// Initialize Variables
			this.isLoading = true;

			// Customer FeedbackSurvey Model
			this.model = new CustomerFeedbackSurveyModel();

			// Get Components
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			this.environment = this.container.getComponent('Environment');

			// Get Configuration
			this.formHeading = this.environment.getConfig('TTCustomerFeedbackSurvey.formHeading');
			this.formMessage = this.environment.getConfig('TTCustomerFeedbackSurvey.formMessage');
			this.formNotAvailableMessage = this.environment.getConfig('TTCustomerFeedbackSurvey.formNotAvailableMessage');

			// Get ID URL Parameter
			this.surveyID = "";
			if (this.options.routerArguments && this.options.routerArguments[0]) {
				var params = Utils.parseUrlOptions(this.options.routerArguments[0]);
				if (params.id) {
					// Assign Survey ID
					this.surveyID = params.id;
					// Get Transaction and Survey Details
					this.getSurveyDetails();
				}
			}
		
		}

	, 	getSurveyDetails: function () {

			var self = this;

			this.model.fetch({ data: { surveyID: self.surveyID } }).done(function (result) {
				self.surveyDetails = result[0];
				self.isLoading = false;
				self.render();
			});
			
		}

	,	events: {
			'click #submit-survey-feedback': 'submitFeedback',
			'keyup #contact_name': 'removeError',
			'keyup #contact_email': 'removeError',
			'keyup #survey_commments': 'removeError',
			'click [name="survey_score_1"]': 'removeError',
			'click [name="survey_score_2"]': 'removeError',
			'click [name="survey_score_3"]': 'removeError',
			'click [name="survey_score_4"]': 'removeError',
			'keyup #friend_phone': 'validatePhone',
			'keyup [type="email"]': 'validateEmail'
		}

	,	bindings: {
		}

	, 	childViews: {

		}

	,	submitFeedback: function() {
		
			var self = this;
			var promise = jQuery.Deferred();

			// Get Constants
			var orderID = this.surveyDetails.orderID;
			var customerID = this.surveyDetails.customerID;
			var salesRep =  this.surveyDetails.salesRep;
			var salesRepID = this.surveyDetails.salesRepID;

			// Get Input Values
			var contactName = this.$("#contact_name").val();
			var contactEmail = this.$("#contact_email").val();
			var score1 = this.$("input[name='survey_score_1']:checked").val() || "";
			var score2 = this.$("input[name='survey_score_2']:checked").val() || "";
			var score3 = this.$("input[name='survey_score_3']:checked").val() || "";
			var score4 = this.$("input[name='survey_score_4']:checked").val() || "";
			var comments = this.$("#survey_commments").val();
			var friendName = this.$("#friend_name").val();
			var friendEmail = this.$("#friend_email").val();
			var friendPhone = this.$("#friend_phone").val();
			var shareMarketing = this.$('#share_marketing').is(':checked') == true ? "T" : "F";

			// Check if all mandatory fields are populated
			var submitForm = false;

			if (contactName && contactEmail) {
				// Accept Submisstion
				submitForm = true;
			}

			// Show Error Message If Value is Blank
			if (!contactName) {

				var errorCode = 'ERR_FEEDBACK_SURVEY_FULL_NAME_BLANK';
				var message = 'Please enter value for Full Name.';
				var element = '.contact-name-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contact_name');
				Utils.animatedScroll(inputEl);

			}

			if (!contactEmail) {

				var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_BLANK';
				var message = 'Please enter value for Email.';
				var element = '.contact-email-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contact_email');
				Utils.animatedScroll(inputEl);

			}

			if (submitForm) {

				// Safeguard Validation for Phone and Email
				var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

				var invalidEmail = contactEmail && !emailReg.test(contactEmail);
				var invalidFriendEmail = friendEmail && !emailReg.test(friendEmail);
				var invalidFriendPhone = friendPhone && friendPhone.length < 7;

				if (invalidEmail || invalidFriendEmail || invalidFriendPhone) {

					if (invalidEmail) {

						var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_INVALID';
						var message = 'Please enter a valid email address.';
						var element = '.contact-email-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#contact_email');
						Utils.animatedScroll(inputEl);
		
					}

					if (invalidFriendEmail) {

						var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_INVALID';
						var message = 'Please enter a valid email address.';
						var element = '.friend-email-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#friend_email');
						Utils.animatedScroll(inputEl);
		
					}

					if (invalidFriendPhone) {

						var errorCode = 'ERR_FEEDBACK_SURVEY_PHONEL_INVALID';
						var message = 'Phone number should have seven digits or more.';
						var element = '.friend-phone-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#friend_phone');
						Utils.animatedScroll(inputEl);
	
					}

				}

				else {

					// Save Answers to Model
					var customerFeedbackSurveyModel = new CustomerFeedbackSurveyModel();
					customerFeedbackSurveyModel.set("orderID", orderID);
					customerFeedbackSurveyModel.set("customerID", customerID);
					customerFeedbackSurveyModel.set("contactName", contactName);
					customerFeedbackSurveyModel.set("contactEmail", contactEmail);
					customerFeedbackSurveyModel.set("salesRepID", salesRepID);
					customerFeedbackSurveyModel.set("score1", score1);
					customerFeedbackSurveyModel.set("score2", score2);
					customerFeedbackSurveyModel.set("score3", score3);
					customerFeedbackSurveyModel.set("score4", score4);
					customerFeedbackSurveyModel.set("comments", comments);
					customerFeedbackSurveyModel.set("friendName", friendName);
					customerFeedbackSurveyModel.set("friendEmail", friendEmail);
					customerFeedbackSurveyModel.set("friendPhone", friendPhone);
					customerFeedbackSurveyModel.set("shareMarketing", shareMarketing);
					customerFeedbackSurveyModel.save().then(function(response) {

						if (response) {
							
							// Reset Form
							//self.isLoading = true;
							//self.getSurveyDetails();

							// Display Confirmation Page
							var view = new CustomerFeedbackSurveyConfirmationView({
								container: self.container,
							});
							self.layout.showContent(view);

						}

					}).fail(function(e) {
						var a = e;
					});

				}
				
			}

		}

		// Customer suddenly changed mind and requested to make all questions non-mandatory
		// Use this as the submit function in case customer wanted to bring the original validations back
	,	submitFeedbackOriginal: function() {
		
			var self = this;
			var promise = jQuery.Deferred();

			// Get Constants
			var orderID = this.surveyDetails.orderID;
			var customerID = this.surveyDetails.customerID;
			var salesRep =  this.surveyDetails.salesRep;
			var salesRepID = this.surveyDetails.salesRepID;

			// Get Input Values
			var contactName = this.$("#contact_name").val();
			var contactEmail = this.$("#contact_email").val();
			var score1 = this.$("input[name='survey_score_1']:checked").val() || "";
			var score2 = this.$("input[name='survey_score_2']:checked").val() || "";
			var score3 = this.$("input[name='survey_score_3']:checked").val() || "";
			var score4 = this.$("input[name='survey_score_4']:checked").val() || "";
			var comments = this.$("#survey_commments").val();
			var friendName = this.$("#friend_name").val();
			var friendEmail = this.$("#friend_email").val();
			var friendPhone = this.$("#friend_phone").val();
			var shareMarketing = this.$('#share_marketing').is(':checked') == true ? "T" : "F";

			// Check if all mandatory fields are populated
			var submitForm = false;

			if (salesRepID) {
				// Include Score 4 
				submitForm = contactName && contactEmail && score1 && score2 && score3 && score4 && comments;
			} else {
				// Remove Score 4
				submitForm = contactName && contactEmail && score1 && score2 && score3 && comments;
			}

			// Show Error Message If Value is Blank
			if (!contactName) {

				var errorCode = 'ERR_FEEDBACK_SURVEY_FULL_NAME_BLANK';
				var message = 'Please enter value for Full Name.';
				var element = '.contact-name-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contact_name');
				Utils.animatedScroll(inputEl);

			}

			if (!contactEmail) {

				var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_BLANK';
				var message = 'Please enter value for Email.';
				var element = '.contact-email-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contact_email');
				Utils.animatedScroll(inputEl);

			}

			if (!comments) {

				var errorCode = 'ERR_FEEDBACK_SURVEY_COMMENTS_BLANK';
				var message = 'Please enter comments.';
				var element = '.survey-comments-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#survey_commments');
				Utils.animatedScroll(inputEl);

			}

			if (!score1) {
				
				var errorCode = 'ERR_FEEDBACK_SURVEY_SCORE_1_BLANK';
				var message = 'Please select a score.';
				var element = '.score-1-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#feedback_survey_score_1');
				Utils.animatedScroll(inputEl);

			}
			
			if (!score2) {
				
				var errorCode = 'ERR_FEEDBACK_SURVEY_SCORE_2_BLANK';
				var message = 'Please select a score.';
				var element = '.score-2-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#feedback_survey_score_2');
				Utils.animatedScroll(inputEl);

			}

			if (!score3) {
				
				var errorCode = 'ERR_FEEDBACK_SURVEY_SCORE_3_BLANK';
				var message = 'Please select a score.';
				var element = '.score-3-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#feedback_survey_score_3');
				Utils.animatedScroll(inputEl);

			}

			if (salesRepID && !score4) {
				
				var errorCode = 'ERR_FEEDBACK_SURVEY_SCORE_4_BLANK';
				var message = 'Please select a score.';
				var element = '.score-4-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#feedback_survey_score_4');
				Utils.animatedScroll(inputEl);

			}

			if (submitForm) {

				// Safeguard Validation for Phone and Email
				var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

				var invalidEmail = contactEmail && !emailReg.test(contactEmail);
				var invalidFriendEmail = friendEmail && !emailReg.test(friendEmail);
				var invalidFriendPhone = friendPhone && friendPhone.length < 7;

				if (invalidEmail || invalidFriendEmail || invalidFriendPhone) {

					if (invalidEmail) {

						var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_INVALID';
						var message = 'Please enter a valid email address.';
						var element = '.contact-email-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#contact_email');
						Utils.animatedScroll(inputEl);
		
					}

					if (invalidFriendEmail) {

						var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_INVALID';
						var message = 'Please enter a valid email address.';
						var element = '.friend-email-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#friend_email');
						Utils.animatedScroll(inputEl);
		
					}

					if (invalidFriendPhone) {

						var errorCode = 'ERR_FEEDBACK_SURVEY_PHONEL_INVALID';
						var message = 'Phone number should have seven digits or more.';
						var element = '.friend-phone-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#friend_phone');
						Utils.animatedScroll(inputEl);
	
					}

				}

				else {

					// Save Answers to Model
					var customerFeedbackSurveyModel = new CustomerFeedbackSurveyModel();
					customerFeedbackSurveyModel.set("orderID", orderID);
					customerFeedbackSurveyModel.set("customerID", customerID);
					customerFeedbackSurveyModel.set("contactName", contactName);
					customerFeedbackSurveyModel.set("contactEmail", contactEmail);
					customerFeedbackSurveyModel.set("salesRepID", salesRepID);
					customerFeedbackSurveyModel.set("score1", score1);
					customerFeedbackSurveyModel.set("score2", score2);
					customerFeedbackSurveyModel.set("score3", score3);
					customerFeedbackSurveyModel.set("score4", score4);
					customerFeedbackSurveyModel.set("comments", comments);
					customerFeedbackSurveyModel.set("friendName", friendName);
					customerFeedbackSurveyModel.set("friendEmail", friendEmail);
					customerFeedbackSurveyModel.set("friendPhone", friendPhone);
					customerFeedbackSurveyModel.set("shareMarketing", shareMarketing);
					customerFeedbackSurveyModel.save().then(function(response) {

						if (response) {
							
							// Reset Form
							//self.isLoading = true;
							//self.getSurveyDetails();

							// Display Confirmation Page
							var view = new CustomerFeedbackSurveyConfirmationView({
								container: self.container,
							});
							self.layout.showContent(view);

						}

					}).fail(function(e) {
						var a = e;
					});

				}
				
			}

		}

	,	validatePhone: function(e) {

		var $element = this.$(e.target),
		elementId = $element.attr('id'),
		getField = $element.parent().find('input#'+ elementId),
		getValue = getField.val(),
		getErrorDiv = $element.next('div'); 

		if (getValue.length !== 0 && getValue.length < 7) {

			var errorCode = 'ERR_FEEDBACK_SURVEY_PHONEL_INVALID';
			var message = 'Phone number should have seven digits or more.';
			var element = getErrorDiv;
			this.displayError(errorCode, message, element);

		}
		else {
			getErrorDiv.hide();
		}

	}

	,	validateEmail: function(e) {

		var $element = this.$(e.target),
		elementId = $element.attr('id'),
		getField = $element.parent().find('input#'+ elementId),
		getValue = getField.val(),
		getErrorDiv = $element.next('div'); 

		var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	
		if (!emailReg.test(getValue)) {

			var errorCode = 'ERR_FEEDBACK_SURVEY_EMAIL_INVALID';
			var message = 'Please enter a valid email address.';
			var element = getErrorDiv; 
			this.displayError(errorCode, message, element);
			
		}
		else {
			getErrorDiv.hide();
		}

	}

	,	displayError: function(errorCode, message, element) {
				
			var messageView = new CustomerFeedbackSurveyValidationView({
				errorCode: errorCode,
				message: message,
				type: 'error',
				closable: true
			});
			
			this.$(element).show();
			this.$(element).html(messageView.render().$el);

	}

	,	removeError: function(e) {
		var $element = this.$(e.target),
			elementId = $element.attr('id'),
			elementName = $element.attr('name'),
			getValue = $('#'+ elementId).val();

		if (getValue) {

			if (elementId == "contact_name") {
				this.$('.contact-name-error-message').hide();
			}
			if (elementId == "contact_email") {
				this.$('.contact-email-error-message').hide();
			}
			if (elementId == "survey_commments") {
				this.$('.survey-comments-error-message').hide();
			}
			if (elementName == "survey_score_1") {
				this.$('.score-1-error-message').hide();
			}
			if (elementName == "survey_score_2") {
				this.$('.score-2-error-message').hide();
			}
			if (elementName == "survey_score_3") {
				this.$('.score-3-error-message').hide();
			}									
			if (elementName == "survey_score_4") {
				this.$('.score-4-error-message').hide();
			}

		}

	}
		//@method getContext @return Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.View.Context
	,	getContext: function getContext()
		{
			//@class Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.View.Context

			var self = this;

			// Get Survey Details
			this.surveyDetails = this.surveyDetails || [];
			//console.log('Feedback Survey Details', this.surveyDetails);

			// Initialize Variables
			var feedbackCount = "";
			var orderNumber = "";
			var contactEmail = "";
			var contactName = "";
			var salesRepID = "";
			var salesRep = ""; 
			var salesRepFirstName = "";
			var salesRepLastName = "";
			var salesRepFullName = "";

			// If Survey Details exist
			if (!_.isEmpty(this.surveyDetails)) {

				feedbackCount = this.surveyDetails.feedbackCount;
				orderNumber = this.surveyDetails.orderNumber;
				contactName = this.surveyDetails.contactName;
				contactEmail = this.surveyDetails.contactEmail || this.surveyDetails.customerEmail;
				salesRepID =  this.surveyDetails.salesRepID;
				salesRep =  this.surveyDetails.salesRep;
				salesRepFullName = this.surveyDetails.salesRepFullName;

			}

			// Display Variables
			var displayForm = this.surveyID && feedbackCount === "0" ? true : false;
			var displayLoadingMessage = this.surveyID && this.isLoading ? true : false;
			var loadingMessage = Utils.translate('Please wait while the survery form loads...')

			return {	
					displayForm: displayForm
				,	formHeading: this.formHeading
				,	formMessage: displayForm ? this.formMessage : (displayLoadingMessage ? loadingMessage : this.formNotAvailableMessage)
				,	formButtonText: Utils.translate('Submit Feedback')
				,	orderNumber: "Sales Order #" + orderNumber
				,	contactName: contactName
				,	contactEmail: contactEmail
				,	salesRepFullName: salesRepFullName
				,	salesRepID: salesRepID
			};
		}
	});
});
